






























































































































































































import Vue, { PropType } from 'vue';
import {
  ActiveFilterFields,
  Column,
  ColumnItems,
} from '@/components/table/types';
import { DropdownList } from '@/types';
import { FilterTypeField } from '@/components/table/types';
import FieldInput from '@/components/form/FieldInput.vue';
import FieldDatePicker from '@/components/form/FieldDatePicker.vue';
import FieldSelect from '../form/FieldSelect.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'FilterTable',
  props: {
    columns: {
      type: Array as PropType<Array<Column>>,
    },
    filterData: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    FieldInput,
    FieldDatePicker,
    FieldSelect,
  },
  computed: {
    ...mapGetters({
      userCan: 'userCan',
    }),
    columnsData(): Array<Column> {
      return this.columns.filter((column) => {
        if (column.role) {
          return this.userCan(column.role);
        }
        return true;
      });
    },
    datePickerValue(): Array<string> {
      if (!this.selectedColumn || !this.selectedColumn.filterValue) {
        return [];
      }
      if (Array.isArray(this.selectedColumn.filterValue)) {
        return <Array<string>>this.selectedColumn.filterValue;
      }
      return this.selectedColumn.filterValue.toString().split(' - ');
    },
    gridColumns() {
      let column: string = '150px';
      if (this.selectedColumn != null) {
        column += ' 320px';
      }
      if (this.activeFilterFields.length) {
        column += ' 280px';
      }
      return { gridTemplateColumns: column };
    },
    activeFilterFields(): Array<ActiveFilterFields> {
      let data: Array<ActiveFilterFields> = [];
      this.columns.map((column: Column) => {
        if (this.fieldIsUsedInFilter(column)) {
          if (Array.isArray(column.items)) {
            column.items.map((item: ColumnItems) => {
              if (Array.isArray(column.filterValue)) {
                if (
                  item.value &&
                  column.filterValue.includes(String(item.value))
                ) {
                  data.push({
                    name: column.name,
                    field: column.field,
                    filterValue: String(item.value),
                    filterValueLabel: item.label,
                  });
                }
              } else {
                if (column.filterValue == item.value) {
                  data.push({
                    name: column.name,
                    field: column.field,
                    filterValue: String(item.value),
                    filterValueLabel: item.label,
                  });
                }
              }
            });
          } else {
            if (Array.isArray(column.filterValue)) {
              for (const value of column.filterValue) {
                data.push({
                  name: column.name,
                  field: column.field,
                  filterValue: String(value),
                  filterValueLabel: String(value),
                });
              }
            } else if (column.filterValue && column.filterValue != '') {
              data.push({
                name: column.name,
                field: column.field,
                filterValue: String(column.filterValue),
                filterValueLabel: String(column.filterValue),
              });
            }
          }
        }
      });
      return data;
    },
    selectedItems(): Array<ColumnItems> {
      if (!this.selectedColumn || !this.selectedColumn.items) {
        return [];
      }
      return this.selectedColumn.items ? this.selectedColumn.items : [];
    },
    filterIsInput(): boolean {
      if (!this.selectedColumn) {
        return false;
      }
      return (
        this.selectedColumn.filterTypeField == FilterTypeField.FILTER_TYPE_INPUT
      );
    },
    filterIsDropdown(): boolean {
      if (!this.selectedColumn) {
        return false;
      }
      return (
        this.selectedColumn.filterTypeField ==
        FilterTypeField.FILTER_TYPE_DROPDOWN
      );
    },
    filterIsDateRange(): boolean {
      if (!this.selectedColumn) {
        return false;
      }
      return (
        this.selectedColumn.filterTypeField ==
        FilterTypeField.FILTER_TYPE_DATERANGE
      );
    },
    filterIsDropdownField(): boolean {
      if (!this.selectedColumn) {
        return false;
      }
      return (
        this.selectedColumn.filterTypeField ==
        FilterTypeField.FILTER_TYPE_DROPDOWN_FIELD
      );
    },
  },
  methods: {
    isObjectValue(data): boolean {
      if (!data) {
        return false;
      }
      return (
        typeof data === 'object' &&
        !(data instanceof String) &&
        data.hasOwnProperty('value')
      );
    },
    modalClose(event): boolean {
      if (event.path && Array.isArray(event.path)) {
        if (
          !!event.path.find((item) => {
            return (
              item.className &&
              typeof item.className.includes == 'function' &&
              item.className.includes('mx-calendar')
            );
          })
        ) {
          return false;
        }
      }
      this.modal = false;
      return true;
    },
    removeFromFilter(item: ActiveFilterFields) {
      const col = this.columns.find((column: Column) => {
        return column.field == item.field;
      });
      if (!col) {
        return;
      }
      if (Array.isArray(col.filterValue)) {
        this.changeFieldInput(item.filterValue, col, true);
      } else {
        this.changeFieldInput(null, col);
      }
    },
    fieldIsUsedInFilter(column: Column): boolean {
      return !!(
        (column.filterValue !== null && !Array.isArray(column.filterValue)) ||
        (column.filterValue !== null &&
          Array.isArray(column.filterValue) &&
          column.filterValue.length)
      );
    },
    fieldItems(item: Column) {
      this.selectedColumn = item;
    },
    changeFieldInput(value, argColumn, remove: boolean | null = null ) {
      let data = {};
      if (!argColumn) {
        argColumn = this.selectedColumn;
      }
      for (const column of this.columns) {
        if (!argColumn || column.field !== argColumn.field) {
          data[column.field] = column.filterValue;
          continue;
        }

        if (
          !argColumn.filterTypeField ||
          argColumn.filterTypeField === FilterTypeField.FILTER_TYPE_INPUT
        ) {
          if (argColumn.multiple) {
            if (!data[column.field]) {
              if (argColumn.filterValue) {
                data[column.field] = argColumn.filterValue;
              } else {
                data[column.field] = [];
              }
            }

            if (Array.isArray(data[column.field])) {
              const indexValue = data[column.field].indexOf(value);

              if (indexValue !== -1 && remove) {
                data[column.field].splice(indexValue, 1);
              } else if (indexValue !== -1) {
                return;
              } else {
                data[column.field].push(value);
              }
            }
          } else {
            data[column.field] = value;
          }
        }

        if (
          argColumn.filterTypeField ===
          FilterTypeField.FILTER_TYPE_DROPDOWN_FIELD
        ) {
          data[column.field] = value;
        }

        if (
          argColumn.filterTypeField === FilterTypeField.FILTER_TYPE_DATERANGE
        ) {
          if (Array.isArray(value)) {
            data[column.field] = value.join(' - ');
          } else {
            data[column.field] = value;
          }
        }

        if (
          argColumn.filterTypeField === FilterTypeField.FILTER_TYPE_DROPDOWN
        ) {
          if (!data[column.field]) {
            if (argColumn.filterValue) {
              data[column.field] = argColumn.filterValue;
            } else {
              data[column.field] = [];
            }
          }

          let issetValueIndex = null;

          data[column.field].find((data, index) => {
            if (value == data) {
              issetValueIndex = index;
              return true;
            }
            return false;
          });
          if (issetValueIndex == null) {
            data[column.field].push(value);
          } else {
            data[column.field].splice(issetValueIndex, 1);
          }
        }
      }

      this.change(data);
    },
    change(data) {
      this.$emit('change', data);
    },
  },
  data: function () {
    return {
      modal: false as boolean,
      selectedColumn: null as Column | null,
    };
  },
});
